export default __webpack_public_path__ + "static/logo-b4ace7348e69b605c6578513df8c80ab.svg";